import { HttpClientService } from '../../../GenericService/Http.service';
import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
@Injectable()
export class DynamicMenuService extends HttpClientService {

 constructor(http: HttpClient) {
   super(http);
  }
}